import { Link, Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';

import { IconTextButton } from '~/src/dash/components/buttons/IconTextButton';
import { fontSizing, Text } from '~/src/dash/publicaUI';
import {
  extractRouteParams,
  getRoutePath,
  logout,
  RouteAccountSettings,
  RouteAudienceDataShareManager,
  RouteBillingDetailList,
  RouteIPTraceNew,
  RoutePublisherChangeLogs,
  RoutePublisherSettings,
  RouteTeamSettings,
} from '~/src/dash/router/routes';
import { publicaColors } from '~/src/dash/utils/colors';
import { useBaseStore } from '~/src/dash/views/base/contexts';

interface ISettingsMenuLink {
  label: string;
  route: {
    path: string;
    title: string;
  };
  isSuperUserOnly?: boolean;
}

interface ISettingsMenuConfig {
  links: ISettingsMenuLink[];
}

const settingsMenuConfig: ISettingsMenuConfig = {
  links: [
    {
      label: 'General Settings',
      route: RoutePublisherSettings,
    },
    {
      label: 'Account Settings',
      route: RouteAccountSettings,
    },
    {
      label: 'Billing Details *',
      route: RouteBillingDetailList,
      isSuperUserOnly: true,
    },
    {
      label: 'Audience Data Share *',
      route: RouteAudienceDataShareManager,
      isSuperUserOnly: true,
    },
    {
      label: 'Change Logs',
      route: RoutePublisherChangeLogs,
    },
    {
      label: 'IP Trace',
      route: RouteIPTraceNew,
    },
    {
      label: 'Team',
      route: RouteTeamSettings,
    },
  ],
};

export const SettingsMenu = () => {
  const { session, user, isSuperUser } = useBaseStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const onMenuClick = ({ currentTarget }: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(currentTarget);
  };

  const onMenuClose = () => {
    setAnchorEl(undefined);
  };

  return (
    <>
      <IconTextButton
        handleOnClick={(e) => onMenuClick(e)}
        label='Settings'
        iconSlug='gear_small'
      />
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onMenuClose}>
        {settingsMenuConfig.links.map(
          (link) =>
            (!link.isSuperUserOnly || isSuperUser) && (
              <MenuItem>
                <Link
                  style={{
                    textDecoration: 'none',
                    color: publicaColors.veryDarkGray,
                    display: 'inline-block',
                    width: '100%',
                    fontSize: fontSizing.small,
                  }}
                  href={
                    '#' +
                    getRoutePath(
                      link.route,
                      extractRouteParams({
                        session,
                        user,
                      }),
                    )
                  }
                >
                  {link.label}
                </Link>
              </MenuItem>
            ),
        )}
        <MenuItem onClick={logout}>
          <Text small>Logout</Text>
        </MenuItem>
      </Menu>
    </>
  );
};
